import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OficiuPostalComponent } from './oficiu-postal.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [OficiuPostalComponent],
    imports: [
        CommonModule,
        MaterialModule,
    ],
    exports: [OficiuPostalComponent]
})
export class OficiuPostalModule { }
